import dayjs from 'dayjs'

export function formatDateBy(date: Date | string, by: string) {

  return dayjs(date).add(3, 'hours').format(by)
}
